import * as firebase from 'firebase';
import { UploadMetadata, StringFormat } from '@firebase/storage-types';

export interface BasicStorage {

  /**
   * Starts the upload of the blob to the storage reference's path. Returns an AngularFireUploadTask for upload monitoring.
   * Usage:
    uploadFile(event) {
      const file = event.target.files[0];
      const filePath = 'name-your-file-path-here';
      const ref = this.storage.ref(filePath);
      const task = ref.put(file);
    }
   * @param path 
   * @param data 
   * @param metadata 
   */
  put(path: string, data: Blob, metadata?: UploadMetadata): firebase.storage.UploadTask;

  /**
   * Updates an existing item in the array. Accepts a key, database reference, or an unwrapped snapshot.
   * Usage:
    uploadFile(event) {
      const file = event.target.files[0];
      const filePath = 'name-your-file-path-here';
      const ref = this.storage.ref(filePath);
      const task = ref.putString(file);
    }
   * @param path 
   * @param data 
   * @param format 
   * @param metadata 
   */
  putString(path: string, data: string, format?: StringFormat, metadata?: UploadMetadata): firebase.storage.UploadTask;

}